// Disallowed characters for number input
// e, E - scientific notation
const DISABLED_NUMBER_INPUT_CHARACTERS = ['e', 'E', '-', '+', '.', ',']; // Check if the key is a valid number input key

export const isValidNumberInputKey = key => {
  return !DISABLED_NUMBER_INPUT_CHARACTERS.includes(key);
}; // Convert string to integer and
// remove all non-numeric characters

export const strToInteger = str => {
  const result = parseInt(str.replace(/[^0-9-]/g, ''), 10);
  return isNaN(result) ? -1 : result;
}; // Convert string to number and
// remove all non-numeric characters

export const stringToNumber = function (str) {
  let nanValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const result = parseFloat(str.replace(/[^0-9.-]/g, '').split('.').slice(0, 2).join('.'));
  return isNaN(result) ? nanValue : result;
}; // Determine if a value is a finite number

export const isNumeric = value => {
  return /^-?\d+(\.\d+)?$/.test(value.trim());
}; // Determine if a value is a valid number

export const isValidNumber = value => {
  return typeof value === 'number' && !isNaN(value);
}; // Returns the next index

export function createNextIndexGenerator() {
  let index = 0;
  return () => index++;
} // Returns rounded integer value

export const round = value => {
  return parseInt(value.toFixed(0), 10);
}; // Replaces all integers or decimals in a string with a specified replacement string

export function replaceNumbers(input, replacement) {
  return `${input}`.replace(/\d+(?:,\d+)*(?:\.\d+)?/g, replacement);
} // Return two parts array of exponential number (scientific notation)
// Source: https://github.com/shrpne/from-exponential/blob/master/src/helpers.js

export function getExponentialParts(num) {
  return Array.isArray(num) ? num : String(num).split(/[eE]/);
} // Determine if a value is an exponential number (scientific notation)
// Source: https://github.com/shrpne/from-exponential/blob/master/src/helpers.js

export function isExponential(num) {
  const eParts = getExponentialParts(num);
  return !Number.isNaN(Number(eParts[1]));
} // Converts exponential notation to a human readable string (Reverses scientific notation)
// Works opposite to Number.prototype.toExponential()
// https://github.com/shrpne/from-exponential/blob/master/src/index.js

export function fromExponential(num) {
  const eParts = getExponentialParts(num);
  const sign = eParts[0][0] === '-' ? '-' : '';
  const digits = `${eParts[0]}`.replace(/^-/, '');
  const digitsParts = digits.split('.');
  const wholeDigits = digitsParts[0];
  const fractionDigits = digitsParts[1] || '';
  let e = Number(eParts[1]);

  if (e === 0) {
    return `${sign + wholeDigits}.${fractionDigits}`;
  } else if (e < 0) {
    // move dot to the left
    const countWholeAfterTransform = wholeDigits.length + e;

    if (countWholeAfterTransform > 0) {
      // transform whole to fraction
      const wholeDigitsAfterTransform = wholeDigits.substr(0, countWholeAfterTransform);
      const wholeDigitsTransformedToFraction = wholeDigits.substr(countWholeAfterTransform);
      return `${sign + wholeDigitsAfterTransform}.${wholeDigitsTransformedToFraction}${fractionDigits}`;
    } else {
      // not enough whole digits: prepend with fractional zeros
      // first e goes to dotted zero
      let zeros = '0.';
      e = countWholeAfterTransform;

      while (e) {
        zeros += '0';
        e += 1;
      }

      return sign + zeros + wholeDigits + fractionDigits;
    }
  } else {
    // move dot to the right
    const countFractionAfterTransform = fractionDigits.length - e;

    if (countFractionAfterTransform > 0) {
      // transform fraction to whole
      // countTransformedFractionToWhole = e
      const fractionDigitsAfterTransform = fractionDigits.substr(e);
      const fractionDigitsTransformedToWhole = fractionDigits.substr(0, e);
      return `${sign + wholeDigits + fractionDigitsTransformedToWhole}.${fractionDigitsAfterTransform}`;
    } else {
      // not enough fractions: append whole zeros
      let zerosCount = -countFractionAfterTransform;
      let zeros = '';

      while (zerosCount) {
        zeros += '0';
        zerosCount -= 1;
      }

      return sign + wholeDigits + fractionDigits + zeros;
    }
  }
}